module.exports = __webpack_public_path__ + "media/images/hamilton-county-8c60321516b1c449151e331afa02b87a.jpg";